import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Api from '../api'
import Util from '../assets/js/Utils'
import equipConsult from './modules/equipConsult.js'
import MQTT from '../assets/js/mqtt'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    toPayNum: 0, // 需要支付的订单数量
    cartNum: 0, // 购物车数量
    firstCategoryId: NaN,
    firstCategoryTitle: '',
    imgUrl: null, // 图片浏览组件相关
    imgList: [], // 图片浏览组件相关
    activeIndex: 0, // 图片浏览组件相关
    firstUrl: '',
    userInfo: '', // 当前登录人信息
    showImgMask: false,
    qaMsgNum: 0,
    isIphoneX: false
  },
  mutations: {
    changePayNum(state, value) {
      state.toPayNum = value
    },
    changeCartNum(state, value) {
      state.cartNum = value
    },
    changeCategory(state, obj) {
      state.firstCategoryId = obj[0].categoryId
      state.firstCategoryTitle = obj[0].categoryName
    },
    /** 开启图片组件 */
    openImgView(state, value) {
      let _url, _list, _activeIndex
      if (typeof value === 'object') {
        _url = value.imgUrl
        _list = value.imgList ? value.imgList.length > 0 ? value.imgList : [value.imgUrl] : [value.imgUrl]
        _activeIndex = value.activeIndex
      } else {
        _url = value
        _list = [value]
        _activeIndex = 0
      }

      if (Util.isApp()) {
        api.sendEvent({
          name: 'openImgView',
          extra: {
            imgUrl: _url,
            imgList: _list,
            activeIndex: _activeIndex
          }
        })
      } else if (Util.isMPaaS()) {
        window.AlipayJSBridge && AlipayJSBridge.call('gzPhotoBrowser', { // eslint-disable-line
          urls: _list,
          index: _activeIndex
        })
      } else {
        state.imgUrl = _url
        state.imgList = _list
        state.activeIndex = _activeIndex
      }
      state.showImgMask = true
    },
    /** 关闭图片组件 */
    closeImgView(state) {
      state.imgUrl = null
      state.imgList = []
      state.activeIndex = 0
      state.showImgMask = false
    },
    /** ios微信分享时 保存第一页面路由路径 */
    setFirstUrl(state, value) {
      state.firstUrl = value
    },
    /** 保存当前登录人信息 */
    setUserInfo(state, value) {
      state.userInfo = value
      localStorage.setItem('userId', value.userId)
      localStorage.setItem('userInfo', JSON.stringify(value))
      // 连接MQTT
      let source
      if (Util.isApp()) {
        source = 'app'
      } else {
        source = 'weixin'
      }
      MQTT.launch(`${source}_${localStorage.getItem('userId')}_${new Date().getTime()}`)
    },
    changeQaMsgNum(state, value) {
      state.qaMsgNum = value
    },
    judgeIphoneX(state, value) {
      state.isIphoneX = value
    }
  },
  actions: {
    getToPayNum({ commit }, value) {
      commit('changePayNum', value)
    },
    getCartNum({ commit }, value) {
      commit('changeCartNum', value)
    },
    getCategory({ commit }, obj) {
      commit('changeCategory', obj)
    },
    /** 更新当前登陆人信息 */
    refreshUserInfo(context) {
      axios
        .post(Api.POST_BASE_PERSONAL_INFO, {})
        .then(res => {
          res.data.status === 200 && context.commit('setUserInfo', res.data.data)
        }).catch(err => {
          console.error(err)
        })
    },
    getQaMsgNum({ commit }, value) {
      commit('changeQaMsgNum', value)
    }
  },
  getters: {
    getUserName: state => {
      return state.userInfo.uname ? state.userInfo.uname : state.userInfo.nickname ? state.userInfo.nickname : '用户_' + state.userInfo.userId
    }
  },
  modules: {
    equipConsult
  }
})
export default store
